import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    window.location.href = 'https://galataanket.anketekatil.com/';
  }, []);

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa',
      flexDirection: 'column',
    },
    logo: {
      maxWidth: '200px',
      marginBottom: '20px',
    },
    text: {
      fontFamily: 'Arial, sans-serif',
      color: '#333',
      fontSize: '18px',
    }
  };

  return (
    <div style={styles.container}>
      <img src="/Logo_Small.png" alt="Galata Survey Logo" style={styles.logo} />
      <p style={styles.text}>Yönlendiriliyor... / Redirecting...</p>
    </div>
  );
}

export default App;
